import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
// import { Headers, Http, RequestOptions, RequestMethod } from '@angular/http';
//
import { environment } from '../../../../environments/environment';
import { tap, catchError, switchMap, concatMap, map, withLatestFrom, mergeMap, flatMap, merge } from 'rxjs/operators';
// import { of } from 'rxjs/observable/of';
// import { from } from 'rxjs/observable/from';

import * as UserActions from './user.actions';
import * as AuthActions from '../../auth/store/auth.actions';
// import * as FavActions from '../../../providers/listing/favStore/fav.actions';
// import * as SaleActions from '../../../providers/listing/saleStore/sale.actions';
// import * as SoldActions from '../../../providers/listing/soldStore/sold.actions';
// import * as InboxActions from '../../../providers/inbox/store/inbox.actions';
// import * as IapActions from '../../../providers/iap/store/iap.actions';
// import { RestProvider, Token } from '../../../providers/rest/rest.provider';
import { RestError } from '../../../providers/rest/rest.types';
// import { Storage } from '@ionic/storage';
// import { Platform, App, Events } from 'ionic-angular';
// import { NativeStorage } from '@ionic-native/native-storage';
import { Action, Store } from '@ngrx/store';
import * as fromApp from '../../../app.reducer';
// // import { ListingProvider } from '../../../providers/listing/listing.provider';
// import { ServiceProvider } from '../../service/service';
// import { Observable } from 'rxjs/Observable';
// import { User, UserRegistrationViewModel, UserSettings, UserMaker, UserProvider } from '../../../providers/user/user.provider';
// import * as AuthActions from '../../../pages/login/store/login.actions';
// import { PushProvider } from '../../../providers/push/push';
// import { DataProvider } from '../../../providers/data/data';
import { UserService, User, UserMaker } from '../user.service';
import { EMPTY, of } from 'rxjs';
import { ChatService } from '../../chat/chat.service';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { TutorialPage } from 'src/app/pages/tutorial/tutorial.page';
import { FilterService } from '../../filter/filter.service';
import { SavedSearchService } from '../../saved-search/saved-search.service';
import { RecentSearchService } from '../../recent-search/recent-search.service';
import { AuthRedirectService } from '../../auth/auth-redirect.service';
import { Router } from '@angular/router';
import { LATEST_LISTING_KEY } from '../../listing/listing.service';

type AuthSource = 'login' | 'register' | 'social';

@Injectable()
export class UserEffects {
	private _shownTutorial = false;
	private _pendingFreshLogin = false;
	private _pendingAuthSource: AuthSource = 'login';

	constructor(
		private actions$: Actions,
		// private httpClient :HttpClient,
		// private http: Http,
		// private storage: Storage,
		// private platform: Platform,
		// private nativeStorage: NativeStorage,
		// private app: App,
		// private events: Events,
		// private service: ServiceProvider,
		// private rest: RestProvider,
		private store: Store<fromApp.AppState>,
		// private pushProvider: PushProvider,
		// private dataProvider: DataProvider,
		// private userProvider: UserProvider
		private userService: UserService,
		private chatService: ChatService,
		private modalController: ModalController,
		private toastController: ToastController,
		private filterService: FilterService,
		private savedSearchService: SavedSearchService,
		private recentSearchService: RecentSearchService,
		private authRedirectService: AuthRedirectService,
		private router: Router,
		private navCtrl: NavController
	) {}

	getUser$ = createEffect(() =>
		this.actions$.pipe(
			ofType(UserActions.GET_USER),
			switchMap(() =>
				this.userService.getUser().pipe(
					switchMap((data: User | any) => {
						if (data instanceof RestError) {
							return of(new UserActions.SetUserFailed());
						}
						if (data && data['pk']) {
							return of(new UserActions.SetUser(UserMaker.create(data)));
						}
						return of(new UserActions.SetUserFailed());
					}),
					catchError(() => of(new UserActions.SetUserFailed()))
				)
			)
		)
	);

	// getStorage(key:string):Promise<any> {
	//   if(this.platform.is('cordova') && (this.platform.is('ios') || this.platform.is('android'))){
	//     // native storage
	//     return this.nativeStorage.getItem(key)
	//   }else{
	//     // ionic storage
	//     return this.storage.get(key)
	//   }
	// }
	//
	// lookupUserSearches(){
	//   this.userProvider.getUserSearches()
	//   .subscribe((data)=> {
	//     console.log('did lookup user searches');
	//     console.log(data);
	//
	//
	//   })
	// }
	//
	// @Effect()
	// getUser = this.actions$.pipe(
	//   ofType(UserActions.GET_USER),
	//   switchMap( ()=> {
	//     console.log('get user effects !!!!');
	//     return this.httpClient.get<User>( environment.base_api_url+'/auth/users/me/')
	//     .pipe(catchError( (data):any => {
	//             console.log('there was a problem fetching the user!');
	//             console.log(data);
	//           })
	//       )
	//   }),
	//   mergeMap( (user:User) => {
	//     let defaultSettings:UserSettings = {
	//       push: null,
	//       tutorial: null,
	//       location: null
	//     };
	//     console.log('checking storage for settings..');
	//     return Observable.fromPromise(
	//       this.getStorage('settings')
	//       .then(
	//         (data:any):UserSettings => {
	//           console.log('returned data from storage:');
	//           console.log(data);
	//           if(data){
	//             return JSON.parse(data)
	//           }
	//           // console.log(JSON.parse(data));
	//           // return JSON.parse(data);
	//         },
	//         error => console.error(error)
	//       )
	//     )
	//     .pipe(
	//       tap((data)=> {
	//         console.log('tried storage:');
	//         console.log(data);
	//       }),
	//       catchError( (err) => {
	//         console.log('could not load local storage!');
	//         if(err){
	//           console.log(err);
	//         }
	//         return Observable.of({ ...user, settings: defaultSettings })
	//       })
	//     )
	//     .map((response:UserSettings):User => {
	//       console.log('map pipe storage "settings" returned ');
	//       console.log(response);
	//       if(!response){
	//         return UserMaker.create({ ...user, settings: defaultSettings })
	//       }
	//       return UserMaker.create({ ...user, settings: response })
	//     })
	//   }),
	//   concatMap( (userWithSettings:User) => of(new UserActions.SetUser(userWithSettings)))
	// );
	/* getThreads... */

	// Track when a fresh login starts (email login, registration, or social login)
	trackFreshLoginStart$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AuthActions.LOGIN_START, AuthActions.REGISTER_START, AuthActions.SOCIAL_LOGIN_START),
				tap((action: Action) => {
					this._pendingFreshLogin = true;
					if (action.type === AuthActions.REGISTER_START) {
						this._pendingAuthSource = 'register';
					} else if (action.type === AuthActions.SOCIAL_LOGIN_START) {
						this._pendingAuthSource = 'social';
					} else {
						this._pendingAuthSource = 'login';
					}
				})
			),
		{ dispatch: false }
	);

	// Dispatch LOGIN_COMPLETE when SET_USER fires after a fresh login
	dispatchLoginCompleteOnFreshLogin$ = createEffect(() =>
		this.actions$.pipe(
			ofType(UserActions.SET_USER),
			switchMap((action: UserActions.SetUser) => {
				if (this._pendingFreshLogin) {
					this._pendingFreshLogin = false;
					return of(new UserActions.LoginComplete(action.payload));
				}
				return EMPTY;
			})
		)
	);

	checkSeenTutorialOnLogin$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UserActions.SET_USER),
				tap(async () => {
					const seenTutorial = localStorage.getItem('seenTutorial');
					// const seenTutorial = false;
					if (!seenTutorial && !this._shownTutorial) {
						console.log('show tutorial modal');
						this._shownTutorial = true;
						const modal = await this.modalController.create({
							component: TutorialPage,
						});
						await modal.present();
						await modal.onDidDismiss().then(() => {
							const currentTime = new Date().toISOString();
							localStorage.setItem('seenTutorial', currentTime);
						});
					}
				})
			),
		{ dispatch: false }
	);

	showWelcomeToastOnLogin$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UserActions.LOGIN_COMPLETE),
				tap(async (action: UserActions.LoginComplete) => {
					const firstName = action.payload?.first_name;
					const isRegistration = this._pendingAuthSource === 'register';
					const message = isRegistration
						? firstName
							? `Welcome, ${firstName}!`
							: 'Welcome to PonyPlace!'
						: firstName
							? `Welcome back, ${firstName}!`
							: 'Welcome back!';
					const toast = await this.toastController.create({
						message,
						duration: 3000,
						position: 'bottom',
						cssClass: ['welcome-toast', 'toast-bottom'],
					});
					await toast.present();
				})
			),
		{ dispatch: false }
	);

	/**
	 * Handle redirect after successful login/registration.
	 * Uses navigateBack + replaceUrl to pop the auth page from both
	 * Ionic's outlet stack and the browser history.
	 */
	redirectAfterLogin$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UserActions.LOGIN_COMPLETE),
				tap(async () => {
					const topModal = await this.modalController.getTop();
					if (topModal) {
						await topModal.dismiss();
					}

					const redirectUrl = this.authRedirectService.consumeRedirectUrl();
					const currentUrl = this.router.url;
					const onAuthRoute = this.authRedirectService.isAuthRoute(currentUrl);

					if (redirectUrl && redirectUrl !== currentUrl) {
						console.log('Redirecting after login from', currentUrl, 'to:', redirectUrl);
						if (onAuthRoute) {
							this.navCtrl.navigateBack(redirectUrl, { replaceUrl: true });
						} else {
							this.navCtrl.navigateRoot(redirectUrl, { replaceUrl: true });
						}
					} else if (onAuthRoute) {
						this.navCtrl.navigateBack('/home', { replaceUrl: true });
					}
				})
			),
		{ dispatch: false }
	);

	loadUserThreadsOnLogin$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UserActions.SET_USER),
				switchMap(() =>
					this.chatService.getAllThreads().pipe(
						tap((threads) => {
							console.log('Loaded ALL threads:', threads);
							console.log('All thread count: ' + threads.length);
						}),
						catchError((error) => {
							console.error('Error loading threads:', error);
							return EMPTY;
						})
					)
				)
			),
		{ dispatch: false }
	);

	loadSavedSearchesOnLogin$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UserActions.SET_USER),
				switchMap((action: UserActions.SetUser) => {
					const userPk = action.payload?.pk;
					if (!userPk) {
						console.log('No user pk available for saved searches');
						return EMPTY;
					}
					return this.savedSearchService.getSavedSearches(userPk).pipe(
						tap((searches) => {
							console.log('Loaded saved searches:', searches.length);
						}),
						catchError((error) => {
							console.error('Error loading saved searches:', error);
							return EMPTY;
						})
					);
				})
			),
		{ dispatch: false }
	);

	clearChatThreadsOnLogout$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(UserActions.LOGOUT),
				tap(() => {
					this.chatService.clearThreads();
					this.filterService.resetAllFilters();
					this.savedSearchService.clearSavedSearches();
					this.recentSearchService.clearRecentSearches();
					this._shownTutorial = false;

					localStorage.removeItem(LATEST_LISTING_KEY);
					localStorage.removeItem('seenTutorial');

					console.log('All user data cleared on logout.');
				})
			),
		{ dispatch: false }
	);
	//
	// @Effect()
	// createUser = this.actions$.pipe(
	//   ofType(UserActions.CREATE_USER),
	//   tap( (data)=> {
	//     console.log('CREATE_USER effects !!!!');
	//     console.log(data);
	//   }),
	//   switchMap( (data:UserActions.CreateUser)=> {
	//     console.log('CREATE_USER effects !!!!');
	//     console.log(data.payload);
	//
	//     return this.http.post(`${environment.base_api_url}/auth/users/`, data.payload,
	//     new RequestOptions({
	//         headers: new Headers({
	//             'Content-Type': 'application/json',
	//             'Accept': 'application/json; version='+environment.api_version
	//         }),
	//         method: RequestMethod.Post,
	//         body: data.payload,
	//         url: `${environment.base_api_url}/auth/users/`
	//     }))
	//     .map((res) => res.json())
	//     .catch((error) => of(new RestError(error, 'Problem making new user POST.')))
	//     .pipe(
	//       tap((data)=> {
	//         console.log('checking user registration progress:');
	//         console.log(data);
	//       }),
	//       catchError( (data):any => {
	//         console.log('there was a problem creating the user!');
	//         console.log(data);
	//       })
	//     )
	//     .concatMap((result:any | RestError | User ):Observable<any> => {
	//       if(!result || result['error'] || result instanceof RestError){
	//         return of(new UserActions.CreateFailed(result));
	//       }
	//       console.log('created user result:');
	//       console.log(result);
	//
	//       return this.http.post(`${environment.base_api_url}/auth/jwt/create/`, {
	//         email: data.payload.email,
	//         password: data.payload.password
	//       })
	//       .map((res) => res.json())
	//       .concatMap( (response:Token|any) => {
	//         console.log('after jwt/create');
	//         console.log(response);
	//         if(response && response['access'] && result['id']){
	//           delete data.payload['password'];
	//           delete data.payload['username'];
	//           delete data.payload['email'];
	//           let patchedUser = { ...data.payload };
	//           console.log('patching user with:');
	//           console.log(patchedUser);
	//
	//           this.store.dispatch(new AuthActions.ValidToken(response));
	//
	//           return this.http.patch(`${ environment.base_api_url }/auth/users/me/`,
	//           patchedUser,
	//           new RequestOptions({
	//               headers: new Headers({
	//                   'Content-Type': 'application/json',
	//                   'Accept': 'application/json; version='+environment.api_version,
	//                   'Authorization': 'JWT ' + response['access']
	//               }),
	//               method: RequestMethod.Patch,
	//               body: patchedUser,
	//               url: `${ environment.base_api_url }/auth/users/me/`
	//           }))
	//           .map((res) => <User>res.json())
	//           .map((finalData:User|any)=> {
	//             console.log("user create and patch concatMap:");
	//             console.log(finalData);
	//             if(finalData && finalData['first_name']){
	//               console.log("we have created a user!!");
	//               this.dataProvider.newUserWasCreated = finalData;
	//               finalData['settings'] = {
	//                 push: '',
	//                 tutorial: false,
	//                 location: null,
	//                 pk: ''
	//               };
	//               console.log('returning SetUser()');
	//               return new UserActions.SetUser(finalData)
	//             }
	//           })
	//           .catch((error) => of(new RestError(error, 'Problem making new user PATCH.')))
	//         }
	//       })
	//       .catch((error) => of(new RestError(error, 'Problem making create-login POST.')));
	//     })
	//
	//   })
	// )
	//
	// @Effect({ dispatch: false })
	// logoutUser = this.actions$.pipe(
	//   ofType(UserActions.LOGOUT),
	//   tap( (data)=> {
	//     console.log('UserActions.LOGOUT user.effects !!!!');
	//
	//     if(this.pushProvider.pushIsActive){
	//       console.log('this user had push activated.. will shut down.');
	//       this.pushProvider.stopPush();
	//     }
	//     if(this.service.loading){
	//       this.service.loading.dismiss()
	//     }
	//   })
	// )
}
